module.exports = __webpack_public_path__ + "5f121880469f1b47cb10eec46ca10e57.svg";